import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  /** 알람(low/high/twa/stel) 발생 시 경보음 재생 여부 */
  alarmSoundEnabled: boolean;
  setAlarmSoundEnabled: (enabled: boolean) => void;
  toggleAlarmSound: () => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    set => ({
      alarmSoundEnabled: true,

      setAlarmSoundEnabled: (enabled: boolean) => {
        set({ alarmSoundEnabled: enabled });
      },

      toggleAlarmSound: () => {
        set(state => ({ alarmSoundEnabled: !state.alarmSoundEnabled }));
      },
    }),
    {
      name: 'settings-storage',
      partialize: state => ({
        alarmSoundEnabled: state.alarmSoundEnabled,
      }),
    }
  )
);
